import React from 'react'

export default function RightIcon() {
  return (
    <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="doneIcon"
    
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.82 6.195c.24.26.24.683 0 .943L9.974 17.805c-.24.26-.63.26-.87 0L4.18 12.47a.707.707 0 0 1 0-.942c.24-.26.63-.26.87 0l4.488 4.861L18.95 6.195c.24-.26.63-.26.87 0Z"
      fill="#0f0"
    />
  </svg>
  )
}
